import React from 'react';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import config from 'config';
/* This component is used in
components/common/statsmenu.jsx
components/pages/comparison/charts/dailychart/index.jsx
components/pages/comparison/charts/rangechart/index.jsx
components/pages/comparison/charts/totalchart/index.jsx
*/
const optionClicked = (props, tag) => {
  props.chooseTag(tag);
}
const TagSelector = (props) => {
  let multiOption = props.roomType === 'meeting_room';
  return (
    multiOption ?
      <Dropdown className={props.className} header={props.tag} toggleable>
        <div>
          <DropdownItem>
            <div onClick={optionClicked.bind(this, props, "Occupancy")}>
              {config.tag.OCCUPANCY.type}
            </div>
          </DropdownItem>
          <DropdownItem>
            <div onClick={optionClicked.bind(this, props, "Efficiency")}>
              {config.tag.EFFICIENCY.type}
            </div>
          </DropdownItem>
        </div>
      </Dropdown>
      :
      <div className={`dropdown-default-text ${props.className}`}>{props.tag}</div>
  )
}
export default TagSelector




// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/tagselector/index.jsx